<template>
  <v-card flat>
    <v-card-text>
      <template>
        <v-card class="main-content-card" flat>
          <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
              <v-flex d-flex xs10>
                <v-layout row wrap>
                  <v-flex xs12 sm2>
                    <v-menu
                      ref="menuIncomeDateStart"
                      :close-on-content-click="false"
                      v-model="menuIncomeDateStart"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editItem.incomeDateStart"
                        label="起始时间"
                        :rules="rules.startDate"
                        hint="格式YYYY-MM, 如：2018-10"
                        persistent-hint
                      />
                      <v-date-picker
                        v-model="incomeDateStart"
                        type="month"
                        locale="zh-cn"
                        @change="nv => editItem.incomeDateStart= nv"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-menu
                      ref="menuIncomeDateEnd"
                      :close-on-content-click="false"
                      v-model="menuIncomeDateEnd"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editItem.incomeDateEnd"
                        label="截止时间"
                        :rules="rules.endDate"
                        hint="格式YYYY-MM, 如：2018-10"
                        persistent-hint
                      />
                      <v-date-picker
                        v-model="incomeDateEnd"
                        type="month"
                        locale="zh-cn"
                        @change="nv => editItem.incomeDateEnd= nv"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-autocomplete
                      autofocus
                      label="教师姓名"
                      item-text="name"
                      item-value="dbid"
                      autocomplete
                      clearable
                      required
                      :loading="userLoading"
                      :items="userItems"
                      :search-input.sync="nameSearch"
                      v-model="editItem.userId"
                      hint="输入教师姓名"
                      persistent-hint
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex xs2 text-xs-center>
                <div>
                  <v-btn color="primary" @click="onSearch">
                    <v-icon dark>search</v-icon>
                    检索
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-divider/>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <!--  科研规模年度统计 -->
            <v-flex xs12 sm6 md6 lg4 style="height: 240px" v-if="this.userId !=''">
              <v-card tile>
                <v-card-text>
                </v-card-text>
                <v-card-text>
                  <teacher-fund-contract-receive-by-date
                    :start-date="startDate"
                    :end-date="endDate"
                    :user-id="userId"/>
                </v-card-text>
                <v-card-text>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg8  style="height: 240px" v-if="this.userId !=''">
              <v-card tile>
                <v-card-text class="text-xs-center">
                  <teacher-fund-by-year-statistics
                    :start-date="startDate"
                    :end-date="endDate"
                    :user-id="userId"
                    style="max-width: 400px;margin: 0 auto;"/>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="this.userId.length !=''">
              <teacher-fund-count-by-level-and-index
                :start-date="startDate"
                :end-date="endDate"
                :user-id="userId"/>
            </v-flex>
            <v-flex xs12 v-if="this.userId ===''">
              <teacher-project-level-statistics
                :start-date="startDate"
                :end-date="endDate"/>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import TeacherFundByYearStatistics from './TeacherFundByYearStatistics'
  import TeacherFundContractReceiveByDate from './TeacherFundContractReceiveByDate'
  import TeacherFundCountByLevelAndIndex from './TeacherFundCountByLevelAndIndex'
  import TeacherProjectLevelStatistics from './TeacherProjectLevelStatistics'
  export default {
    name: "TeacherFundSearch",
    components: {
      TeacherFundContractReceiveByDate,
      TeacherFundByYearStatistics,
      TeacherFundCountByLevelAndIndex,
      TeacherProjectLevelStatistics
    },
    data () {
      return {
        userURI: '/api/syst/user/search',
        startDate: "",
        endDate: "",
        userId:"",
        loading: false,
        //开始时间
        menuIncomeDateStart: false,
        incomeDateStart:null,

        menuIncomeDateEnd: false,
        incomeDateEnd:null,
        editItem: {
          "incomeDateStart":"",
          "incomeDateEnd": "",
          "userId":""
        },
        userLoading: false,
        userItems: [],
        nameSearch: '',
        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'],
          startDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpMonth().test(v) || '日期格式错误'
          ],
          endDate: [
            v => !!v || "必填项。",
            v => (v && window.xutil.regexpMonth().test(v)) || '日期格式错误',
            v => (v && v > this.editItem.incomeDateStart) || "截止日期必须晚于起始日期。"
          ]
        },

      }
    },
    created() {
      const vm = this;
      if (vm.editItem.incomeDateStart) {
        const val = vm.editItem.incomeDateStart.trim();
        if (val.length > 0) {
          vm.startDate = val;
        }
      }
      else {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear()-9;
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        var enddate = year + seperator1 + month;
        vm.editItem.incomeDateStart = enddate;
        vm.startDate = enddate;
      }
      if (vm.editItem.incomeDateEnd) {
        const val = vm.editItem.incomeDateEnd.trim();
        if (val.length > 0) {
          vm.endDate = val;
        }
      }
      else {
        var currentdate = new Date().toISOString().substr(0,7);
        vm.editItem.incomeDateEnd = currentdate;
        vm.endDate = currentdate;
      }
      if (vm.editItem.userId) {
        const val = vm.editItem.userId.trim();
        if (val.length > 0) {
          vm.userId = val;
        }
      }
      else{
        vm.userId = "";
      }
    },
    watch: {
      nameSearch(val) {
        val && val.length && this.onNameSearch();
      }
    },

    computed: {

    },

    methods: {
      onNameSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.nameSearch);

        vm.userLoading = true;
        this.axios.get(vm.userURI, {params: param})
          .then(
            rsp => {
              vm.userLoading = false;
              vm.userItems = rsp.data.items
            })
      },
      // 检索响应函数
      onSearch() {
        const vm = this;
        if (vm.editItem.incomeDateStart) {
          const val = vm.editItem.incomeDateStart.trim();
          if (val.length > 0) {
            vm.startDate = val;
          }
        }
        else {
          var date = new Date();
          var seperator1 = "-";
          var year = date.getFullYear()-9;
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          var enddate = year + seperator1 + month;
          vm.editItem.incomeDateStart = enddate;
          vm.startDate = enddate;
        }
        if (vm.editItem.incomeDateEnd) {
          const val = vm.editItem.incomeDateEnd.trim();
          if (val.length > 0) {
            vm.endDate = val;
          }
        }
        else {
          var currentdate = new Date().toISOString().substr(0,7);
          vm.editItem.incomeDateEnd = currentdate;
          vm.endDate = currentdate;
        }
        if (vm.editItem.userId) {
          const val = vm.editItem.userId.trim();
          if (val.length > 0) {
            vm.userId = val;
          }
        }
        else{
          vm.userId = "";
        }
      }
    }
  }
</script>

<style scoped>

</style>
